import { TableContainer, TableHeader, TableHeaderRow, TableHeaderCell, TableBody, TableRow, TableCell } from '@sainsburys-tech/luna-table';
import { Tick, Cancel } from '@sainsburys-tech/luna-icons';
import * as React from 'react';
export default {
  TableContainer,
  TableHeader,
  TableHeaderRow,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  Tick,
  Cancel,
  React
};